/**
 * BonusInfo defines model for free bets data
 *
 * @typedef BonusInfo
 * @type {Object}
 * @property {name} String name of the Free bet
 * @property {bonusId} String id of free bet
 * @property {amount} number amount of free bet
 */
var BonusInfo = /** @class */ (function () {
    function BonusInfo(source) {
        this.name = source.name;
        this.bonusId = source.bonusId;
        this.amount = source.amount;
        this.title = source.title;
        this.isRiskFreeBet = source.isRiskFreeBet;
    }
    return BonusInfo;
}());
export { BonusInfo };
//# sourceMappingURL=BonusInfo.js.map